import React from 'react';
import { Route } from 'react-router-dom';
import {Nav, Navbar, NavItem} from 'react-bootstrap';
import { LinkContainer } from "react-router-bootstrap";
import FullArticle from '../../components/fullarticle';
import News from '../news';
import Privacy from '../privacy';
import Contact from '../contact';
import logo from '../../resources/oldawg_168-150x150.png';

const App = () => (
  <div className="App container">
    <Navbar fluid collapseOnSelect>
        <Navbar.Collapse>
            <Nav pullLeft>
            <LinkContainer to="/">
                <NavItem><img src={logo} className="App-logo" alt="logo" /></NavItem>
            </LinkContainer>
            </Nav>
            <Nav pullRight>
                <LinkContainer to="/">
                    <NavItem>Home</NavItem>
                </LinkContainer>
                <LinkContainer to="/news">
                    <NavItem>News</NavItem>
                </LinkContainer>
                <LinkContainer to="/privacy">
                    <NavItem>Privacy</NavItem>
                </LinkContainer>
                <LinkContainer to="/contact">
                    <NavItem>Contact</NavItem>
                </LinkContainer>
            </Nav>
        </Navbar.Collapse>
    </Navbar>

    <main>
        <Route exact path="/" render={() => <FullArticle tag='home-article' />} />
        <Route exact path="/news" component={News} />
        <Route exact path="/privacy" component={Privacy} />
        <Route exact path="/contact" component={Contact} />
        <Route exact path="/play-fling" render={() => <FullArticle tag='play-fling' />} />
        <Route exact path="/fling-amazon" render={() => <FullArticle tag='fling-amazon' />} />
        <Route exact path="/fling-coming-amazon-appstore" render={() => <FullArticle tag='fling-coming-amazon-appstore' />} />
        <Route exact path="/fling-google-play" render={() => <FullArticle tag='fling-google-play' />} />
        <Route exact path="/upcoming-release-fling-it" render={() => <FullArticle tag='upcoming-release-fling-it' />} />
    </main>
  </div>
)

export default App;